import script from "./InsuranceCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./InsuranceCalculation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__